import { useQuery } from "@tanstack/react-query";
import { RiskItem } from "../types";
import { programmeDashboardApi } from "../api/programmeDashboard";
import { FilterItem } from "../../../shared/context/FilterContext";
import { extractFilterValues } from "../../../lib/filterUtils";

const mapApiRiskToRiskItem = (apiRisk: {
  risk_id: string;
  title: string;
  risk_description: string;
  project_ref?: string;
  category?: string;
  status?: string;
  impact_score?: number;
  probability_score?: number;
}): RiskItem => {
  const impactScore = apiRisk.impact_score ?? 0;
  const probabilityScore = apiRisk.probability_score ?? 0;
  const riskScore = impactScore * probabilityScore;

  return {
    id: apiRisk.risk_id,
    title: apiRisk.title,
    description: apiRisk.risk_description,
    project_ref: apiRisk.project_ref,
    category: apiRisk.category,
    status: apiRisk.status,
    impact_score: apiRisk.impact_score,
    probability_score: apiRisk.probability_score,
    risk_score: riskScore > 0 ? riskScore : undefined,
  };
};

export const useRisks = (category: string, { portfolio_id, quickFilters }: { portfolio_id: string | undefined, quickFilters: any }) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["risks", category, portfolio_id, quickFilters],
    queryFn: () => programmeDashboardApi.fetchRisks({
      page: 1,
      limit: 5,
      sort_field: "impact_score",
      sort_order: "ASC",
      category,
      status: "open",
      portfolio_id: portfolio_id,
      workstream_id: extractFilterValues(quickFilters.workstream) || null,
      site_id: extractFilterValues(quickFilters.site) || null,
      programme_id: extractFilterValues(quickFilters.programme) || null,
      region_id: extractFilterValues(quickFilters.region) || null,
      work_type_group_id: extractFilterValues(quickFilters['worktype-group']) || null,
      project_year: extractFilterValues(quickFilters.projectYear) || null,
    }),
  });

  const risks: RiskItem[] = data?.data?.rows
    ? data.data.rows.map(mapApiRiskToRiskItem)
    : [];

  return {
    risks,
    isLoading,
    isError,
    error:
      error instanceof Error ? error.message : "Failed to fetch risks",
  };
};

